import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { environment } from '@app-environments/environment';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { UserService } from '@app-services/user/user.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
// import { MobileScreen } from '@app-helpers/functions';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-self-learn-video-playback',
  templateUrl: './self-learn-video-playback.component.html',
  styleUrls: ['./self-learn-video-playback.component.css']
})
export class SelfLearnVideoPlaybackComponent implements OnInit {
  @ViewChild('video') videoComp: any;
  userLikeStatus:boolean = false;
  userDislikeStatus:boolean = false;
  playlists:any = [];
  videoFullData:any ;
  videoDetailsPlayList:any;
  currentPlayListIndex:any;
  currentVideoPosition = 0;
  isVideoCompleted = false;
  subjectIcon:any;
  isVideoLsqSent: boolean = true;
  userData: any;
  watchedInSec;
  videoLikeCount: any;

  constructor(public dialog: MatDialog, public router: Router, public selfLearnService:SelfLearnService, public spinner:NgxSpinnerService,private firebaseService: FirebaseService,private userService: UserService,public sanitizer: DomSanitizer,private ngZone: NgZone,public gaService: GAnalyticsService) { }

  urlSafe: any;
  videoFullscreenStatus:any = false;
  isVideoPlaying:any = true;
  youTubeTimeinterval:any;
  videoPlaybackStatus:any = false;
  currentVideoPlaybackSpeed:any = 1;
   


  ngOnInit(): void {
    this.userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    const isFromChapterScreen = (localStorage.getItem("selfLearnPreviousPage") == 'chapter') || (localStorage.getItem("selfLearnPreviousPage") == 'subject') ? true : false;
    this.getVideoData(videoId);
    if(isFromChapterScreen){
   
      if(localStorage.getItem("selfLearnSelectedPlayList") && localStorage.getItem("selfLearnSelectedPlayName")){
        this.getPlayList();
      }else {
        this.getTopicsAndVideosForExamChapterSubtenant();
      }
    }else if(localStorage.getItem("selfLearnPreviousPage")=='selfLearn-V2/practice-questions' ||localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/revise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/exercise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/pyp-chapter-questions' || localStorage.getItem("selfLearnPreviousPage")=='selfLearn-V2/exercise-solution'){
      this.getVideoProgressForSolutionVideo(videoId);
    }
    else {
      const videoType = localStorage.getItem("selfLearnSelectedVideoType");
      if(videoType == 'reviseVideos'){
        if(JSON.parse(localStorage.getItem('reviseVideosPlayList'))){
          this.playlists= JSON.parse(localStorage.getItem('reviseVideosPlayList'));
          this.getVideosDetailForPlayListId(666, videoId);
        }else{
          this.getReviseByVideos(videoId)
        }

      }else{
        this.getPlayList();
      }
  
    }
    
  }
  getReviseByVideos(videoId:any){
    this.selfLearnService.getChapterReviseByVideos().subscribe((res:any) =>{
      console.log(res);
      this.playlists  = res.data;
      this.getVideosDetailForPlayListId(666, videoId);
    })
  }

  getPlayList(){
    const playListId = localStorage.getItem('selfLearnSelectedPlayList');
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    const isFromChapterScreen = (localStorage.getItem("selfLearnPreviousPage") == 'chapter') || (localStorage.getItem("selfLearnPreviousPage") == 'subject')? true : false;
    const params = {
      examId: this.selfLearnService.getCmsExamID(),
      subTenantId: this.selfLearnService.getSubtenantId(),
      playlistTypeId: playListId,
    }
    this.selfLearnService.getVideosByPlayListId(params).subscribe((resp:any) => {
      let videos:any;
      this.playlists= [];
      videos = resp.data
      videos.map((item:any) => {
        item.videos.map((video:any) => {
          this.playlists.push(video);
        })

      })
      //this.playlists = resp.data[0].videos;
      this.getVideosDetailForPlayListId(playListId, videoId);
      if(isFromChapterScreen) {this.getVideoProgressByTopic()};
    })
  }

    getVideoProgressByTopic(videoId?:any){
      this.selfLearnService.getVideoProgressByTopic().subscribe((resp:any) => {
        this.playlists = this.playlists.map((video:any) => {
          const found = resp?.data?.find((element:any) => video.videoId == element.videoId);
         
          if(found){
            video['completed'] = found.isCompleted;
            video['isBookmarked'] = found.isBookmarked;
            video['watchedContentInSecs'] = found.watchedContentInSecs;
            video['isLiked'] = found?.isLiked;
            video['isDisliked'] = found?.isDisliked
          }
          else{
            video['completed'] = false;
            video['isBookmarked'] = false;
            video['isLiked'] = false
            video['isDisliked'] = false
        }
          return video;
        })
        console.log(this.playlists);
        if(videoId){this.setPlayListIndex(videoId)};
    })
  }

  userLike(){
    let index:any =this.playlists.findIndex((item:any) => item.videoId == this.videoFullData.videoId)
    this.playlists[index].isLiked = true;
    this.playlists[index].isDisliked = false;
    this.userLikeStatus = !this.userLikeStatus;

    let payload:any = this.constructPayloadforLikeandDislike();
    this.selfLearnService.storeVideoProgress(payload).subscribe((resp:any) => {
      this.getVideoLikeCount(this.videoFullData.videoId);
    })
  }
  userDislike(){
    let index:any =this.playlists.findIndex((item:any) => item.videoId == this.videoFullData.videoId)
    this.playlists[index].isDisliked = true;
    this.playlists[index].isLiked = false;
    this.userDislikeStatus = !this.userDislikeStatus;
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {assetType:"video"}
    });
    
    dialogRef.afterClosed().subscribe(() => {
    });

    
    let payload:any = this.constructPayloadforLikeandDislike();
    this.selfLearnService.storeVideoProgress(payload).subscribe((resp:any) => {
      this.getVideoLikeCount(this.videoFullData.videoId);
    })
  }

  navigateToPreviousPage(){
    let previousPage ; 
    let isFromHomeScren = localStorage.getItem('isFromHomeScreen');
    isFromHomeScren == "true" ?  localStorage.getItem('previousScreen')? previousPage = localStorage.getItem('previousScreen'): previousPage='home' : previousPage = localStorage.getItem("selfLearnPreviousPage");
  
    let navigationPath;
    switch (previousPage) {
      case 'home':
        navigationPath = 'selfLearn-V2';
        break;
      case 'chapter':
        navigationPath = 'selfLearn-V2/chapter';
        break;
      case 'subject':
          navigationPath = 'selfLearn-V2/subject';
          break;
      case 'selfLearn-V2/bookmarks':
            navigationPath = 'selfLearn-V2/bookmarks';
            break;
      case 'selfLearn-V2/my-library':
          navigationPath = 'selfLearn-V2/my-library';
          break;
      case 'selfLearn-V2/practice-questions':
          localStorage.setItem('isItFromVideoSolution','true');
          navigationPath = 'selfLearn-V2/practice-questions';
          break;
      case 'selfLearn-V2/revise-questions':
        localStorage.setItem('isItFromVideoSolution','true');
           navigationPath = 'selfLearn-V2/revise-questions';
           break;
      case 'selfLearn-V2/exercise-questions':
           localStorage.setItem('isItFromVideoSolution','true');
           navigationPath = 'selfLearn-V2/exercise-questions';
           break;
      case 'selfLearn-V2/pyp-chapter-questions':
            localStorage.setItem('isItFromVideoSolution','true');
            navigationPath   = 'selfLearn-V2/pyp-chapter-questions';
            break;
      case 'selfLearn-V2/my-history':
          navigationPath = 'selfLearn-V2/my-history';
          break;
      case  'selfLearn-V2/exercise-solution':
          navigationPath = 'selfLearn-V2/exercise-solution';
          break;
      case  'selfLearn-V2/chapter':
           navigationPath = 'selfLearn-V2/chapter';
            break;
      default:
        navigationPath = 'selfLearn-V2/videos';
        break;
    }
    localStorage.removeItem('isFromHomeScreen');
    if(this.watchedInSec >= 15){
      this.sendLsqData(this.watchedInSec);
     }
    this.router.navigateByUrl(navigationPath);
  }

  onVideoSelected(videoData:any){
    this.getVideoData(videoData.videoId, true);
    this.resetVideoStatus();
  }

  videoEnded(){
    ++this.currentPlayListIndex;
    this.resetVideoStatus()
    this.playNextVideo();
  }

  getVideoData(videoId:any, callSetPlayListIndex?:boolean){
    this.spinner.show();
    clearInterval(this.youTubeTimeinterval);
    this.getVideoLikeCount(videoId);
    this.selfLearnService.getVideoCms(videoId).subscribe((resp:any) => {
      this.videoFullData = { ...resp?.video }
      localStorage.setItem("selfLearnSelectedVideoId", this.videoFullData.videoId);
      if(localStorage.getItem("selfLearnPreviousPage")=='selfLearn-V2/practice-questions' ||localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/revise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/exercise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/pyp-chapter-questions'){
        this.getVideoProgressForSolutionVideo(videoId);
      }
      if(this.videoFullData.sourceName =="Youtube"){
        localStorage.setItem('ytSettings', 'false');
        this.getYTLinkAndSetParameters(this.videoFullData.videoURL)
      }
      this.spinner.hide();
      if(callSetPlayListIndex){setTimeout(() => {
        this.setPlayListIndex(videoId)
      }, 500);}
      // this.videoFullData.videoURL = (this.videoFullData.videoURL).replace('https://', 'http://');
    })
  }

  playNextVideo(){
    const nextVideo = this.playlists[this.currentPlayListIndex];
    this.getVideoData(nextVideo.videoId, true);
    this.playlists[this.currentPlayListIndex].resume = true;
  }

  setPlayListIndex(videoId:any){
    for (let index = 0; index < this.playlists.length; index++) {
      const element = this.playlists[index];
      if(element.videoId == videoId){
        this.currentPlayListIndex = index;
        this.playlists[index].resume = true;
        if(element.watchedContentInSecs && !element.completed){
          if(element?.sourceName == "Youtube"){
            this.resumeYtVideo(element.watchedContentInSecs)           
          }
          else{
            this.setVideoSeekTime(element.watchedContentInSecs);
          }
        }
        return;
      }
    }
  }

  setVideoSeekTime(seconds:any){
    this.videoComp.nativeElement.currentTime = seconds;
  }


  resetVideoStatus(){
    this.playlists.forEach((video:any) => {
      video.resume = false;
   });
   this.currentVideoPosition = 0;
   this.isVideoCompleted = false;
   if(this.watchedInSec >= 15){
    this.sendLsqData(this.watchedInSec);
   }
  //  this.gaService.webEngageEvent({ 
  //   event: 'self_learn_video', 
  //   topic: localStorage.getItem('selectedTopicName'),
  //   duration_watched: this.watchedInSec,
  //   // teacher_name: this.selfLearnService.getSubjectName(),
  //   // module:this.selfLearnService.getSubjectName(),//todo
  //   // package_price:,//todo
  //   subject:this.selfLearnService.getSubjectName(),
  //   page_url:window.location.href,
  //   chapter:this.selfLearnService.getChapterName(),
  //   platform: MobileScreen()? "MWEB":"WEB",
  // });
  }

  getVideosDetailForPlayListId(playListId:any, videoId:any){
    this.selfLearnService.getVideoDetailsForPlatListTypeId(playListId).subscribe((resp:any) => {
      this.videoDetailsPlayList = resp.videos;
      this.setVideoDetailsForPlayList(videoId);
    })
  }

  setVideoDetailsForPlayList(videoId:any){
   this.playlists.forEach((playList:any) => {
    this.videoDetailsPlayList.forEach((element:any) => {
      if(playList.videoId == element?.videoId){
        playList['completed'] = element?.isCompleted;
        playList['watchedContentInSecs'] = element.watchedContentInSecs;
        playList['isBookmarked'] = element?.isBookmarked;
        playList['isLiked'] = element?.isLiked
        playList['isDisliked'] = element?.isDisLiked
      }
    });
   });
   console.log(this.playlists);
   this.setPlayListIndex(videoId);
  }

   getTopicsAndVideosForExamChapterSubtenant(){
    const chapterId = localStorage.getItem("chapterId");
    const topicId = localStorage.getItem("selfLearnSelectedTopicId");
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    this.selfLearnService.getTopicsAndVideosForExamChapterSubtenant(chapterId).subscribe((resp:any) => {
      this.subjectIcon = resp?.data?.parent?.icon;
      this.playlists = resp?.data?.child.filter((topic:any) => topic.topicId == topicId)[0].videos;
      this.getVideoProgressByTopic(videoId);
    })
  }

  dispatchEventsOnTimeUpdate(event:any){
    if(this.selfLearnService.isFromLearn() && event.srcElement.currentTime > 16 && this.isVideoLsqSent == true){
      this.isVideoLsqSent = false;
    }
    const currentVideoPosition = (event.srcElement.currentTime.toFixed(2) / event.srcElement.duration) * 100;
     this.watchedInSec = event.srcElement.currentTime.toFixed(2);
    if(((event.srcElement.currentTime - this.currentVideoPosition) > 30 || currentVideoPosition >= 85) && !this.isVideoCompleted){
      this.storeVideoProgress(currentVideoPosition, this.watchedInSec);
      if(currentVideoPosition >= 85){this.isVideoCompleted = true}
      this.currentVideoPosition = event.srcElement.currentTime;
    }
  }

  storeVideoProgress(currentVideoPosition:any, watchedInSec:any){
    if(localStorage.getItem("selfLearnSelectedPlayName") == 'Recommended'){
      this.getSubjectIdOfRecomendedVideos( Number(this.selfLearnService.getVideoId()));
    }
    if(localStorage.getItem('previousScreen') !='selfLearn-V2/bookmarks' && localStorage.getItem('previousScreen') !='selfLearn-V2/my-library' && localStorage.getItem('previousScreen') != 'selfLearn-V2/my-library'){ //we are not allowed to hit progress API when it video from my-library
      let storeVideoProgressPayLoad :any =  this.constructJsonForStoreVideoProgress(currentVideoPosition, watchedInSec)
      this.selfLearnService.storeVideoProgress(storeVideoProgressPayLoad).subscribe((resp:any) => {
        if(resp && currentVideoPosition > 85){this.playlists[this.currentPlayListIndex].completed = true}
        if(localStorage.getItem("selfLearnSelectedPlayName") == 'Recommended'){
          localStorage.removeItem("selfLearnSelectedSubject");
        }
      })
    }

  }
  getSubjectIdOfRecomendedVideos(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video.videoId == videoId)
     console.log(videoData);
     localStorage.setItem("selfLearnSelectedSubject" , videoData.subjects[0].subjectId);
    
   }
   isVideoBookMarked(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video?.videoId == videoId)
      return videoData?.isBookmarked;
    
   }
   isVideoLiked(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video?.videoId == videoId);
    return videoData?.isLiked;
   }
   isVideoDisLiked(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video?.videoId == videoId)
    return videoData?.isDisliked;
   }

  constructJsonForStoreVideoProgress(currentVideoPosition:any, watchedInSec:any){
    return {
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: this.selfLearnService.getGradeId(),
      subjectId: Number(this.selfLearnService.getSubjectId()),
      chapterId: Number(this.selfLearnService.getChapterId()),
      chapterName:this.selfLearnService.getChapterName(),
      topicId: Number(this.selfLearnService.getTopicId()),
      playlistTypeId: Number(this.selfLearnService.getPlayListId()),
      topicName: localStorage.getItem('selectedTopicName'),
      videoId: Number(this.selfLearnService.getVideoId()),
      videoName: (this.videoFullData.title),
      watchedContentInSecs: Number(watchedInSec),
      isCompleted: (currentVideoPosition >= 85) ? true : false,
      isBookmarked: this.isVideoBookMarked(this.videoFullData.videoId),
      isLiked: this.isVideoLiked(this.videoFullData.videoId),
      isDisLiked: this.isVideoDisLiked(this.videoFullData.videoId)
    };
  }
  constructPayloadforLikeandDislike(){
    return {
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: this.selfLearnService.getGradeId(),
      subjectId: Number(this.selfLearnService.getSubjectId()),
      chapterId: Number(this.selfLearnService.getChapterId()),
      chapterName:this.selfLearnService.getChapterName(),
      topicId: Number(this.selfLearnService.getTopicId()),
      playlistTypeId: Number(this.selfLearnService.getPlayListId()),
      topicName: localStorage.getItem('selectedTopicName'),
      videoId: Number(this.selfLearnService.getVideoId()),
      videoName: (this.videoFullData.title),
      isBookmarked: this.isVideoBookMarked(this.videoFullData.videoId),
      isLiked: this.isVideoLiked(this.videoFullData.videoId),
      isDisLiked: this.isVideoDisLiked(this.videoFullData.videoId)
    };
  }

  sendLsqData(watchTime: any) {
    let payload={
      data:{
      video_study_video : this.videoFullData.title,
      video_duration_watched : watchTime,
      video_subject:this.selfLearnService.getSubjectName(),
      video_chapter:this.selfLearnService.getChapterName()
      },
      landingPage : "LSQ_CUSTOM_EVENTS"
    }
    let  mPayload={}
    // console.log(payload);
    // isUserAdmin(this.userService).then((bool) => {
      // if(!bool) {
        // this.selfLearnService.callTrackingAPI2(payload,'Act_Self_Learn_Video').subscribe((data)=>{console.log(data);
        // })
      // }
    // })
    this.firebaseService.getSqsValue().then((firebaseRSP) => {
      mPayload = {
        mx_Custom_1 : this.videoFullData.title,
        mx_Custom_2 : watchTime,
        mx_Custom_3:localStorage.getItem('selfLearnSelectedSubjectName'),
        mx_Custom_4:localStorage.getItem("chapterName")
      }
      this.userService.sendSQSMsgOptim(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,mPayload,264);
    }).catch((e) => {
      console.log(e);
    });
  }

  //to get video solutuion progress
getVideoProgressForSolutionVideo(videoId:any){
    this.selfLearnService.getVideoProgressForSolutionVideo(videoId).subscribe((res:any)=>{
      this.videoFullData.isBookmarked = res?.isBookmarked ? res?.isBookmarked : false
      this.videoFullData.isCompleted = res?.isCompleted ? res?.isComplete : false
      this.videoFullData.isLiked = res?.isLiked ? res?.isLiked : false
      this.videoFullData.isDisliked = res?.isDisLiked ? res?.isDisLiked : false
      this.videoFullData.watchedContentInSecs = res?.watchedContentInSecs ? res?.watchedContentInSecs : false
      if( this.playlists.length <=0){
        this.playlists.push(this.videoFullData);
      }
      this.setVideoSeekTime(res.watchedContentInSecs);
    })
}
getVideoLikeCount(videoId:any){
  this.selfLearnService.getVideoLikeCount(videoId).subscribe((res:any) => {
    this.videoLikeCount = res.likeCount;
    console.log(res)
  })
}
getYTLinkAndSetParameters(videoURL:any){
  const lsYtLink = videoURL
  const urlParams = new URL(lsYtLink).searchParams;
  const iframe = document.getElementById('iframe-id');
  // iframe.setAttribute('donotallowfullscreen', '');
  const ytUrl = urlParams.get('v')
  this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+ytUrl+'?autoplay=1&enablejsapi=1&modestbranding=1');
  const ytSettings = localStorage.getItem('ytSettings');
  if(!(window['YT'])){
    window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (event,currentTime,isVideoEnded,totalDuration) => this.angularFunctionCalled(event,currentTime,isVideoEnded,totalDuration), };  
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag,firstScriptTag)
    localStorage.setItem('ytSettings', 'true');
    this.youTubeTimer();
  }else{
    window.location.reload();
  }
}
divdblClick(event:any){
  const currentX = event.clientX;
  const offSetWidth = event.currentTarget.clientWidth;
  if(currentX < offSetWidth/2){
    this.seekTo(-10);
  }else if(currentX > offSetWidth/2){
    this.seekTo(10);
  }
  this.isVideoPlaying = !this.isVideoPlaying;
  this.divClick('');
}
seekTo(seekValue){
  (<any>window)?.seekVideo(seekValue)?.call &&  (<any>window)?.seekVideo(seekValue);
}
divClick(event:any){
  if(this.isVideoPlaying){
    this.pauseVideo();
  }else{
    this.playVideo();
  }
  this.isVideoPlaying = !this.isVideoPlaying;
  // else if(){
  //   this.playVideo();
  // }
}
pauseVideo(){
  //this.changePlaybackSpeed();
  //@ts-ignore
  window?.pauseVideo?.call && window?.pauseVideo();
}

playVideo(){
  //@ts-ignore
  window?.playVideo?.call && window?.playVideo();
}
angularFunctionCalled(data:any,currentTime:any,isVideoEnded:any,totalDuration:any){
  console.log(data,currentTime);
  console.log(totalDuration,'duration',isVideoEnded);
  if(currentTime < 0.5 && this.playlists[this.currentPlayListIndex].watchedContentInSecs && !this.playlists[this.currentPlayListIndex].completed){
   this.seekTo(this.playlists[this.currentPlayListIndex].watchedContentInSecs);
  }
  const currentVideoPosition = (Number(currentTime)/ Number(totalDuration)) * 100;
  const watchedInSec = Number(currentTime);
  if(data.data !=1 && data.data != 2){
    this.storeVideoProgress(currentVideoPosition,watchedInSec);
  }
  if(isVideoEnded){
    ++this.currentPlayListIndex;
    this.resetVideoStatus();
    this.playNextVideo();

  }


  // this.videoStatus = data;
  // if(this.videoStatus != -1){
  //   this.showFullScreenIconAndFeedBackPopup = true;
  // }
}

youTubeTimer(){
  if(!(window['YT'])){
  this.youTubeTimeinterval = setInterval(() => {
    this.storeVideoProgress(this.playlists[this.currentPlayListIndex].completed ? 90 : 70,(<any>window)?.getCurrenVideoTime());    
  },30000)
}
}
showFullScreen() {
  this.videoFullscreenStatus = true;
  var elem = document.getElementById("video-iframe-container");
  //@ts-ignore
  if (elem.requestFullscreen) {
    //@ts-ignore
    elem.requestFullscreen();
  }  
}
exitFullScreen(){
  this.videoFullscreenStatus = false;
  if (document.exitFullscreen) {
    document.exitFullscreen();
  }
}
changePlaybackSpeed(speed:any){
  this.currentVideoPlaybackSpeed = speed;
  (<any>window)?.changePlaybackSpeed(speed)?.call &&  (<any>window)?.changePlaybackSpeed(speed);
  this.playVideo();
}
resumeYtVideo(watchedInSec:any){
  (<any>window)?.resumeVideo(watchedInSec)?.call &&  (<any>window)?.resumeVideo(watchedInSec);
}
ngOnDestroy() { 
  clearInterval(this.youTubeTimeinterval);
}





videoFullscreenCheck() {
  if (window.innerWidth >= 991) {
    if (window.innerHeight == screen.height) {
      // browser is fullscreen
      this.videoFullscreenStatus = true;
    } else {
      this.videoFullscreenStatus = false;
    }
  } else {
    //@ts-ignore
    if (window.innerHeight == document.getElementById("video-iframe-container").offsetHeight) {
      // browser is fullscreen
      this.videoFullscreenStatus = true;
    } else {
      this.videoFullscreenStatus = false;
    }
  }
}

ngAfterViewInit() {
  setInterval(() => { this.videoFullscreenCheck() }, 500);
}

videoPlayback(){
  this.videoPlaybackStatus = !this.videoPlaybackStatus;
}

}
